// TODO move implementation from user service here if possible
// import {IStrategyPermissions} from '../../models/IStrategyPermissions';

export class Role {
  readonly roleName: string;
  readonly status: string;
  readonly institutionId: number;
  readonly permissionList: string[] = [];
  roleValue?: number;

  constructor() { }
}

export interface IUser {
  readonly id: number;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly acceptTandC: boolean;
  readonly applicationRole: Role;
  readonly userAssociations?: Role[];
  isStrategiesUser(): boolean;
  // TODO move implementation from user service here if possible
  // getPermissions(): IStrategyPermissions;
}

export class User implements IUser {
  readonly id: number;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly acceptTandC: boolean;
  readonly applicationRole: Role;
  readonly userAssociations: Role[];

  constructor(other: IUser) {
    this.id = other.id;
    this.firstName = other.firstName;
    this.lastName = other.lastName;
    this.email = other.email;
    this.acceptTandC = other.acceptTandC;
    this.applicationRole = other.applicationRole;
    this.userAssociations = other.userAssociations;
  }

  isStrategiesUser(): boolean {
    if (this.applicationRole) {
      return true;
    } else if (this.userAssociations) {
      return this.userAssociations.length > 0;
    } else {
      return false;
    }
  }
}
